export default {

  // Получение поста по ID
  getPostById: (state, getters, rootState, rootGetters) => id => {
    let entity = { id: id, loaded: false }

    if (state.posts[id]) {
      entity = Object.assign({}, state.posts[id], { loaded: true })
    }

    return entity
  },

  // Получение контейнера по ID
  getContainerById: state => id => {
    let entity = { id: id, loaded: false }

    if (state.containers[id]) {
      entity = Object.assign({}, state.containers[id], { loaded: true })
    }
    
    return entity
  },

  //Список всех постов из дерева
  posts: state => {
    if (state.structure.length === 0) {
      return false
    }
    return []
  },

  //Список всех контейнеров из дерева
  containers: state => {
    if (state.structure.length === 0) {
      return false
    }
    return []
  }
}



// WEBPACK FOOTER //
// ./src/apps/org/store/common/org/getters.js